import {
  Box,
  Space,
  unsafeLocalizedString,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../intl";
import * as classes from "../../MortgageDashboard/Documents/Section.css";

type Props = {
  note: string;
};

export function DocumentNote(props: Props) {
  const formatMessage = useFormatMessage();
  return (
    <Box>
      <Box className={classes.noteTitle}>
        {formatMessage("Mortgage.Documents.accordion.notePrefix")}
      </Box>
      <Space units={1} />
      <Box shrink className={classes.noteBody}>
        {unsafeLocalizedString(props.note)}
      </Box>
    </Box>
  );
}
